export default __webpack_public_path__ + "static/media/bg.c0c1234a.png";